import * as actionTypes from './actionTypes';

import { createActionObject, getNoArgDispatcherFunc } from '../../helpers/common';

import * as strings from '../../helpers/strings';

export const setEmail = email => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_EMAIL,
    { 
      email,
      emailError: email ? "" : strings.msgEmailRequired
    }
  )
)

export const toggleAlertDialog = getNoArgDispatcherFunc(actionTypes.TOGGLE_ALIERT_DIALOG);